import { render, staticRenderFns } from "./MetalinkNavigation.vue?vue&type=template&id=418ebbb6"
import script from "./MetalinkNavigation.vue?vue&type=script&lang=js"
export * from "./MetalinkNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports